let currentPage = 1;
let sort = "-published_at";
let showMenu = false;

const reviewsSection = document.querySelector(".review-block");

async function fetchData() {
  const res = await fetch(
    `https://hempelf-review-app.herokuapp.com/?page=${currentPage}&sort=${sort}`
  );
  const result = await res.json();
  // console.log(result);
  return result;
}

// Update UI
async function main() {
  const result = await fetchData();
  console.log(result);
  const total = document.querySelector(".review-left-content");
  total.innerHTML = `<h4>${(result.total + 3600).toLocaleString('en-US')}+ <span>Total Reviews</span></h4>`;

  const reviewsAvg = document.querySelector(".review-star");
  reviewsAvg.innerHTML = `
        <p>
            <svg
              width="130"
              height="24"
              viewBox="0 0 130 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
            ${
              result.total >= 1 && result.total < 2
                ? `<path
              d="M13 0L15.9187 8.98278H25.3637L17.7225 14.5344L20.6412 23.5172L13 17.9656L5.35879 23.5172L8.27747 14.5344L0.636266 8.98278H10.0813L13 0Z"
              fill="#618C6E"
            ></path>`
                : result.total >= 2 && result.total < 3
                ? `<path
            d="M13 0L15.9187 8.98278H25.3637L17.7225 14.5344L20.6412 23.5172L13 17.9656L5.35879 23.5172L8.27747 14.5344L0.636266 8.98278H10.0813L13 0Z"
            fill="#618C6E"
          ></path>
            ` +
                  `<path
            d="M39 0L41.9187 8.98278H51.3637L43.7225 14.5344L46.6412 23.5172L39 17.9656L31.3588 23.5172L34.2775 14.5344L26.6363 8.98278H36.0813L39 0Z"
            fill="#618C6E"
          ></path>`
                : result.total >= 3 && result.total < 4
                ? `<path
                d="M13 0L15.9187 8.98278H25.3637L17.7225 14.5344L20.6412 23.5172L13 17.9656L5.35879 23.5172L8.27747 14.5344L0.636266 8.98278H10.0813L13 0Z"
                fill="#618C6E"
              ></path>
                ` +
                  `<path
                d="M39 0L41.9187 8.98278H51.3637L43.7225 14.5344L46.6412 23.5172L39 17.9656L31.3588 23.5172L34.2775 14.5344L26.6363 8.98278H36.0813L39 0Z"
                fill="#618C6E"
              ></path>` +
                  `<path
              d="M65 0L67.9187 8.98278H77.3637L69.7225 14.5344L72.6412 23.5172L65 17.9656L57.3588 23.5172L60.2775 14.5344L52.6363 8.98278H62.0813L65 0Z"
              fill="#618C6E"
            ></path>`
                : result.total >= 4 && result.total < 5
                ? `<path
                d="M13 0L15.9187 8.98278H25.3637L17.7225 14.5344L20.6412 23.5172L13 17.9656L5.35879 23.5172L8.27747 14.5344L0.636266 8.98278H10.0813L13 0Z"
                fill="#618C6E"
              ></path>
                ` +
                  `<path
                d="M39 0L41.9187 8.98278H51.3637L43.7225 14.5344L46.6412 23.5172L39 17.9656L31.3588 23.5172L34.2775 14.5344L26.6363 8.98278H36.0813L39 0Z"
                fill="#618C6E"
              ></path>` +
                  `<path
              d="M65 0L67.9187 8.98278H77.3637L69.7225 14.5344L72.6412 23.5172L65 17.9656L57.3588 23.5172L60.2775 14.5344L52.6363 8.98278H62.0813L65 0Z"
              fill="#618C6E"
            ></path>` +
                  `<path
            d="M91 0L93.9187 8.98278H103.364L95.7225 14.5344L98.6412 23.5172L91 17.9656L83.3588 23.5172L86.2775 14.5344L78.6363 8.98278H88.0813L91 0Z"
            fill="#618C6E"
          ></path>`
                : `<path
                d="M13 0L15.9187 8.98278H25.3637L17.7225 14.5344L20.6412 23.5172L13 17.9656L5.35879 23.5172L8.27747 14.5344L0.636266 8.98278H10.0813L13 0Z"
                fill="#618C6E"
              ></path>` +
                  `<path
              d="M39 0L41.9187 8.98278H51.3637L43.7225 14.5344L46.6412 23.5172L39 17.9656L31.3588 23.5172L34.2775 14.5344L26.6363 8.98278H36.0813L39 0Z"
              fill="#618C6E"
            ></path>` +
                  `<path
            d="M65 0L67.9187 8.98278H77.3637L69.7225 14.5344L72.6412 23.5172L65 17.9656L57.3588 23.5172L60.2775 14.5344L52.6363 8.98278H62.0813L65 0Z"
            fill="#618C6E"
          ></path>` +
                  `<path
          d="M91 0L93.9187 8.98278H103.364L95.7225 14.5344L98.6412 23.5172L91 17.9656L83.3588 23.5172L86.2775 14.5344L78.6363 8.98278H88.0813L91 0Z"
          fill="#618C6E"
        ></path>` +
                  `<path
        d="M117 0L119.919 8.98278H129.364L121.723 14.5344L124.641 23.5172L117 17.9656L109.359 23.5172L112.277 14.5344L104.636 8.98278H114.081L117 0Z"
        fill="#618C6E"
      ></path>`
            }
            </svg>
            ${result.reviewsAvg} Review Score
        </p>
  `;

  reviewsSection.innerHTML = ""; //removing old Data set
  for (let i = 0; i < result.reviews.length; i++) {
    reviewsSection.innerHTML += `
    <div class="review-block-body">
        <div class="review-block-top">
          <div class="review-block-left">
            <div class="customer-circle">
              <h6>${result.reviews[i].name?.slice(0, 1)}</h6>
              <div class="varified-icon">
                <svg
                  width="1024px"
                  height="1024px"
                  viewBox="0 0 1024 1024"
                  class="icon"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="currentColor"
                    d="M512 64a448 448 0 110 896 448 448 0 010-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 10-54.336 54.336l126.72 126.72a38.272 38.272 0 0054.336 0l262.4-262.464a38.4 38.4 0 10-54.272-54.336L456.192 600.384z"
                  ></path>
                </svg>
              </div>
            </div>
            <h3>${result.reviews[i].name}, <span>Verified</span></h3>
          </div>
          <div class="review-start">
          <svg class="mysvg" width="128" height="23" viewBox="0 0 128 23" fill="none"
          xmlns="http://www.w3.org/2000/svg">
            ${ratingByConsumer(result.reviews[i].rating)}
       </svg>
          </div>
          <span>
          ${moment(result.reviews[i].published_at, "YYYYMMDD").fromNow()}
          </span>
        </div>
        <p>
          ${result.reviews[i].text || ""}
        </p>
      </div>
    `;
  }
  document
    .querySelectorAll(".pagination ul li a")
    .forEach((item, i) =>
      item.classList.toggle("active", currentPage === i + 1)
    );
}
main();

// pagination
async function handlePagination() {
  const result = await fetchData();
  const pagination = document.querySelector(".pagination");
  // previous page
  pagination.querySelector(".prev").addEventListener("click", async () => {
    const result = await fetchData();
    if (currentPage > 1) {
      currentPage--;
      reviewsSection.innerHTML = "";
      main();
    }
  });
  // next page
  pagination.querySelector(".next").addEventListener("click", () => {
    if (result.totalPages > currentPage) {
      currentPage++;
      reviewsSection.innerHTML = "";
      main();
    }
  });
  // page numbers for pagination
  let paginationUl = document.querySelector(".pagination ul");
  for (let i = 1; i <= result.totalPages; i++) {
    let li = document.createElement("li");
    let a = document.createElement("a");
    a.textContent = i;
    a.classList.toggle("active", currentPage === i);
    a.addEventListener("click", () => {
      currentPage = i;
      reviewsSection.innerHTML = "";
      main();
    });
    li.appendChild(a);
    paginationUl.appendChild(li);
  }
}
handlePagination();

// rating provided by consumer
function ratingByConsumer(rating) {
  return rating === 1
    ? `<path
    d="M11.6196 1.17082C11.7393 0.802298 12.2607 0.802296 12.3804 1.17082L14.8289 8.70638C14.8824 8.87119 15.036 8.98278 15.2093 8.98278H23.1327C23.5202 8.98278 23.6813 9.47862 23.3678 9.70639L16.9576 14.3636C16.8174 14.4655 16.7588 14.646 16.8123 14.8108L19.2608 22.3464C19.3805 22.7149 18.9587 23.0214 18.6452 22.7936L12.2351 18.1364C12.0949 18.0345 11.9051 18.0345 11.7649 18.1364L5.35475 22.7936C5.04127 23.0214 4.61947 22.7149 4.73921 22.3464L7.18767 14.8108C7.24122 14.646 7.18255 14.4655 7.04236 14.3636L0.632227 9.70639C0.318741 9.47863 0.47985 8.98278 0.867339 8.98278H8.7907C8.96399 8.98278 9.11757 8.87119 9.17112 8.70639L11.6196 1.17082Z"
    fill="#618C6E"></path>`
    : rating === 2
    ? `<path
    d="M11.6196 1.17082C11.7393 0.802298 12.2607 0.802296 12.3804 1.17082L14.8289 8.70638C14.8824 8.87119 15.036 8.98278 15.2093 8.98278H23.1327C23.5202 8.98278 23.6813 9.47862 23.3678 9.70639L16.9576 14.3636C16.8174 14.4655 16.7588 14.646 16.8123 14.8108L19.2608 22.3464C19.3805 22.7149 18.9587 23.0214 18.6452 22.7936L12.2351 18.1364C12.0949 18.0345 11.9051 18.0345 11.7649 18.1364L5.35475 22.7936C5.04127 23.0214 4.61947 22.7149 4.73921 22.3464L7.18767 14.8108C7.24122 14.646 7.18255 14.4655 7.04236 14.3636L0.632227 9.70639C0.318741 9.47863 0.47985 8.98278 0.867339 8.98278H8.7907C8.96399 8.98278 9.11757 8.87119 9.17112 8.70639L11.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M37.6196 1.17082C37.7393 0.802298 38.2607 0.802296 38.3804 1.17082L40.8289 8.70638C40.8824 8.87119 41.036 8.98278 41.2093 8.98278H49.1327C49.5202 8.98278 49.6813 9.47862 49.3678 9.70639L42.9576 14.3636C42.8174 14.4655 42.7588 14.646 42.8123 14.8108L45.2608 22.3464C45.3805 22.7149 44.9587 23.0214 44.6452 22.7936L38.2351 18.1364C38.0949 18.0345 37.9051 18.0345 37.7649 18.1364L31.3548 22.7936C31.0413 23.0214 30.6195 22.7149 30.7392 22.3464L33.1877 14.8108C33.2412 14.646 33.1826 14.4655 33.0424 14.3636L26.6322 9.70639C26.3187 9.47863 26.4798 8.98278 26.8673 8.98278H34.7907C34.964 8.98278 35.1176 8.87119 35.1711 8.70639L37.6196 1.17082Z"
    fill="#618C6E"></path>`
    : rating === 3
    ? `<path
    d="M11.6196 1.17082C11.7393 0.802298 12.2607 0.802296 12.3804 1.17082L14.8289 8.70638C14.8824 8.87119 15.036 8.98278 15.2093 8.98278H23.1327C23.5202 8.98278 23.6813 9.47862 23.3678 9.70639L16.9576 14.3636C16.8174 14.4655 16.7588 14.646 16.8123 14.8108L19.2608 22.3464C19.3805 22.7149 18.9587 23.0214 18.6452 22.7936L12.2351 18.1364C12.0949 18.0345 11.9051 18.0345 11.7649 18.1364L5.35475 22.7936C5.04127 23.0214 4.61947 22.7149 4.73921 22.3464L7.18767 14.8108C7.24122 14.646 7.18255 14.4655 7.04236 14.3636L0.632227 9.70639C0.318741 9.47863 0.47985 8.98278 0.867339 8.98278H8.7907C8.96399 8.98278 9.11757 8.87119 9.17112 8.70639L11.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M37.6196 1.17082C37.7393 0.802298 38.2607 0.802296 38.3804 1.17082L40.8289 8.70638C40.8824 8.87119 41.036 8.98278 41.2093 8.98278H49.1327C49.5202 8.98278 49.6813 9.47862 49.3678 9.70639L42.9576 14.3636C42.8174 14.4655 42.7588 14.646 42.8123 14.8108L45.2608 22.3464C45.3805 22.7149 44.9587 23.0214 44.6452 22.7936L38.2351 18.1364C38.0949 18.0345 37.9051 18.0345 37.7649 18.1364L31.3548 22.7936C31.0413 23.0214 30.6195 22.7149 30.7392 22.3464L33.1877 14.8108C33.2412 14.646 33.1826 14.4655 33.0424 14.3636L26.6322 9.70639C26.3187 9.47863 26.4798 8.98278 26.8673 8.98278H34.7907C34.964 8.98278 35.1176 8.87119 35.1711 8.70639L37.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M63.6196 1.17082C63.7393 0.802298 64.2607 0.802296 64.3804 1.17082L66.8289 8.70638C66.8824 8.87119 67.036 8.98278 67.2093 8.98278H75.1327C75.5202 8.98278 75.6813 9.47862 75.3678 9.70639L68.9576 14.3636C68.8174 14.4655 68.7588 14.646 68.8123 14.8108L71.2608 22.3464C71.3805 22.7149 70.9587 23.0214 70.6452 22.7936L64.2351 18.1364C64.0949 18.0345 63.9051 18.0345 63.7649 18.1364L57.3548 22.7936C57.0413 23.0214 56.6195 22.7149 56.7392 22.3464L59.1877 14.8108C59.2412 14.646 59.1826 14.4655 59.0424 14.3636L52.6322 9.70639C52.3187 9.47863 52.4798 8.98278 52.8673 8.98278H60.7907C60.964 8.98278 61.1176 8.87119 61.1711 8.70639L63.6196 1.17082Z"
    fill="#618C6E"></path>
    `
    : rating === 4
    ? `<path
    d="M11.6196 1.17082C11.7393 0.802298 12.2607 0.802296 12.3804 1.17082L14.8289 8.70638C14.8824 8.87119 15.036 8.98278 15.2093 8.98278H23.1327C23.5202 8.98278 23.6813 9.47862 23.3678 9.70639L16.9576 14.3636C16.8174 14.4655 16.7588 14.646 16.8123 14.8108L19.2608 22.3464C19.3805 22.7149 18.9587 23.0214 18.6452 22.7936L12.2351 18.1364C12.0949 18.0345 11.9051 18.0345 11.7649 18.1364L5.35475 22.7936C5.04127 23.0214 4.61947 22.7149 4.73921 22.3464L7.18767 14.8108C7.24122 14.646 7.18255 14.4655 7.04236 14.3636L0.632227 9.70639C0.318741 9.47863 0.47985 8.98278 0.867339 8.98278H8.7907C8.96399 8.98278 9.11757 8.87119 9.17112 8.70639L11.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M37.6196 1.17082C37.7393 0.802298 38.2607 0.802296 38.3804 1.17082L40.8289 8.70638C40.8824 8.87119 41.036 8.98278 41.2093 8.98278H49.1327C49.5202 8.98278 49.6813 9.47862 49.3678 9.70639L42.9576 14.3636C42.8174 14.4655 42.7588 14.646 42.8123 14.8108L45.2608 22.3464C45.3805 22.7149 44.9587 23.0214 44.6452 22.7936L38.2351 18.1364C38.0949 18.0345 37.9051 18.0345 37.7649 18.1364L31.3548 22.7936C31.0413 23.0214 30.6195 22.7149 30.7392 22.3464L33.1877 14.8108C33.2412 14.646 33.1826 14.4655 33.0424 14.3636L26.6322 9.70639C26.3187 9.47863 26.4798 8.98278 26.8673 8.98278H34.7907C34.964 8.98278 35.1176 8.87119 35.1711 8.70639L37.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M63.6196 1.17082C63.7393 0.802298 64.2607 0.802296 64.3804 1.17082L66.8289 8.70638C66.8824 8.87119 67.036 8.98278 67.2093 8.98278H75.1327C75.5202 8.98278 75.6813 9.47862 75.3678 9.70639L68.9576 14.3636C68.8174 14.4655 68.7588 14.646 68.8123 14.8108L71.2608 22.3464C71.3805 22.7149 70.9587 23.0214 70.6452 22.7936L64.2351 18.1364C64.0949 18.0345 63.9051 18.0345 63.7649 18.1364L57.3548 22.7936C57.0413 23.0214 56.6195 22.7149 56.7392 22.3464L59.1877 14.8108C59.2412 14.646 59.1826 14.4655 59.0424 14.3636L52.6322 9.70639C52.3187 9.47863 52.4798 8.98278 52.8673 8.98278H60.7907C60.964 8.98278 61.1176 8.87119 61.1711 8.70639L63.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M89.6196 1.17082C89.7393 0.802298 90.2607 0.802296 90.3804 1.17082L92.8289 8.70638C92.8824 8.87119 93.036 8.98278 93.2093 8.98278H101.133C101.52 8.98278 101.681 9.47862 101.368 9.70639L94.9576 14.3636C94.8174 14.4655 94.7588 14.646 94.8123 14.8108L97.2608 22.3464C97.3805 22.7149 96.9587 23.0214 96.6452 22.7936L90.2351 18.1364C90.0949 18.0345 89.9051 18.0345 89.7649 18.1364L83.3548 22.7936C83.0413 23.0214 82.6195 22.7149 82.7392 22.3464L85.1877 14.8108C85.2412 14.646 85.1826 14.4655 85.0424 14.3636L78.6322 9.70639C78.3187 9.47863 78.4798 8.98278 78.8673 8.98278H86.7907C86.964 8.98278 87.1176 8.87119 87.1711 8.70639L89.6196 1.17082Z"
    fill="#618C6E"></path>
    `
    : `<path
    d="M11.6196 1.17082C11.7393 0.802298 12.2607 0.802296 12.3804 1.17082L14.8289 8.70638C14.8824 8.87119 15.036 8.98278 15.2093 8.98278H23.1327C23.5202 8.98278 23.6813 9.47862 23.3678 9.70639L16.9576 14.3636C16.8174 14.4655 16.7588 14.646 16.8123 14.8108L19.2608 22.3464C19.3805 22.7149 18.9587 23.0214 18.6452 22.7936L12.2351 18.1364C12.0949 18.0345 11.9051 18.0345 11.7649 18.1364L5.35475 22.7936C5.04127 23.0214 4.61947 22.7149 4.73921 22.3464L7.18767 14.8108C7.24122 14.646 7.18255 14.4655 7.04236 14.3636L0.632227 9.70639C0.318741 9.47863 0.47985 8.98278 0.867339 8.98278H8.7907C8.96399 8.98278 9.11757 8.87119 9.17112 8.70639L11.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M37.6196 1.17082C37.7393 0.802298 38.2607 0.802296 38.3804 1.17082L40.8289 8.70638C40.8824 8.87119 41.036 8.98278 41.2093 8.98278H49.1327C49.5202 8.98278 49.6813 9.47862 49.3678 9.70639L42.9576 14.3636C42.8174 14.4655 42.7588 14.646 42.8123 14.8108L45.2608 22.3464C45.3805 22.7149 44.9587 23.0214 44.6452 22.7936L38.2351 18.1364C38.0949 18.0345 37.9051 18.0345 37.7649 18.1364L31.3548 22.7936C31.0413 23.0214 30.6195 22.7149 30.7392 22.3464L33.1877 14.8108C33.2412 14.646 33.1826 14.4655 33.0424 14.3636L26.6322 9.70639C26.3187 9.47863 26.4798 8.98278 26.8673 8.98278H34.7907C34.964 8.98278 35.1176 8.87119 35.1711 8.70639L37.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M63.6196 1.17082C63.7393 0.802298 64.2607 0.802296 64.3804 1.17082L66.8289 8.70638C66.8824 8.87119 67.036 8.98278 67.2093 8.98278H75.1327C75.5202 8.98278 75.6813 9.47862 75.3678 9.70639L68.9576 14.3636C68.8174 14.4655 68.7588 14.646 68.8123 14.8108L71.2608 22.3464C71.3805 22.7149 70.9587 23.0214 70.6452 22.7936L64.2351 18.1364C64.0949 18.0345 63.9051 18.0345 63.7649 18.1364L57.3548 22.7936C57.0413 23.0214 56.6195 22.7149 56.7392 22.3464L59.1877 14.8108C59.2412 14.646 59.1826 14.4655 59.0424 14.3636L52.6322 9.70639C52.3187 9.47863 52.4798 8.98278 52.8673 8.98278H60.7907C60.964 8.98278 61.1176 8.87119 61.1711 8.70639L63.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M89.6196 1.17082C89.7393 0.802298 90.2607 0.802296 90.3804 1.17082L92.8289 8.70638C92.8824 8.87119 93.036 8.98278 93.2093 8.98278H101.133C101.52 8.98278 101.681 9.47862 101.368 9.70639L94.9576 14.3636C94.8174 14.4655 94.7588 14.646 94.8123 14.8108L97.2608 22.3464C97.3805 22.7149 96.9587 23.0214 96.6452 22.7936L90.2351 18.1364C90.0949 18.0345 89.9051 18.0345 89.7649 18.1364L83.3548 22.7936C83.0413 23.0214 82.6195 22.7149 82.7392 22.3464L85.1877 14.8108C85.2412 14.646 85.1826 14.4655 85.0424 14.3636L78.6322 9.70639C78.3187 9.47863 78.4798 8.98278 78.8673 8.98278H86.7907C86.964 8.98278 87.1176 8.87119 87.1711 8.70639L89.6196 1.17082Z"
    fill="#618C6E"></path>` +
      `<path
    d="M115.62 1.17082C115.739 0.802298 116.261 0.802296 116.38 1.17082L118.829 8.70638C118.882 8.87119 119.036 8.98278 119.209 8.98278H127.133C127.52 8.98278 127.681 9.47862 127.368 9.70639L120.958 14.3636C120.817 14.4655 120.759 14.646 120.812 14.8108L123.261 22.3464C123.381 22.7149 122.959 23.0214 122.645 22.7936L116.235 18.1364C116.095 18.0345 115.905 18.0345 115.765 18.1364L109.355 22.7936C109.041 23.0214 108.619 22.7149 108.739 22.3464L111.188 14.8108C111.241 14.646 111.183 14.4655 111.042 14.3636L104.632 9.70639C104.319 9.47863 104.48 8.98278 104.867 8.98278H112.791C112.964 8.98278 113.118 8.87119 113.171 8.70639L115.62 1.17082Z"
    fill="#618C6E"></path>
    `;
}

//Sort
const sortBy = document.querySelector(".review-sorting");
const dropDownTitle = document.querySelector(".js-link");
const dropDownItems = document.querySelector(".js-dropdown-list");

sortBy.addEventListener("click", () => {
  showMenu = !showMenu;
  if (showMenu) {
    dropDownItems.style.display = "block";
  } else {
    dropDownItems.style.display = "none";
  }
});

sortBy.querySelectorAll("li").forEach((item, i) => {
  item.addEventListener("click", () => {
    dropDownTitle.innerText = item.innerText;
    switch (dropDownTitle.innerText) {
      case "Date (Newest First)":
        sort = "-published_at";
        reviewsSection.innerHTML = "";
        currentPage = 1;
        main();
        break;
      case "Date (Oldest First)":
        sort = "published_at";
        reviewsSection.innerHTML = "";
        currentPage = 1;
        main();
        break;
      case "Ratings (High to Low)":
        sort = "-rating";
        reviewsSection.innerHTML = "";
        currentPage = 1;
        main();
        break;
      case "Ratings (Low to High)":
        sort = "rating";
        reviewsSection.innerHTML = "";
        currentPage = 1;
        main();
        break;
      default:
        sort = "-published_at";
    }
  });
});
